import React from 'react';
import styles from './styles.module.scss';
import {Skeleton} from '@chakra-ui/react';
import classNames from 'classnames';

const OfferSkeleton: React.FC = () => {
  return (
    <div className={styles.item}>
      <div>
        <h2 className={styles.title}>
          <Skeleton height="30px" width="100px" className={styles.skeleton} />
        </h2>
      </div>
      <div className={styles.image}>
        <Skeleton className={classNames(styles.skeleton, styles.skeletonAbsolute)} />
      </div>
      <div className={styles.row}>
        <div className={styles.price}>
          <Skeleton height="30px" width="100px" className={styles.skeleton} />
        </div>
        <Skeleton height="48px" width="120px" className={styles.skeleton} />
      </div>

      {/* 20 reward skeleton items */}
      {Array.from({ length: 20 }, (_, index) => (
        <div key={index} className={classNames(styles.bg)}>
          <Skeleton height="48px" width="120px" className={styles.skeleton} />
        </div>
      ))}

    </div>
  );
};

export default OfferSkeleton;
